import { z } from "zod";

import { lenient, propertyFilterSearch } from "./search.ts";

import type { TaskPriority, TaskSort, TaskStatus, TaskViewId } from "@estate-platform/domain/task-views";

// WHY: type-only mirrors of the domain lists; their runtime module pulls the Temporal polyfill into the first load.
export const taskViews = [
  "myTasks",
  "allOpen",
  "overdue",
  "upcoming",
  "recurring",
  "done",
] as const satisfies readonly TaskViewId[];
export const taskDisplays = ["list", "board", "table"] as const;
export const taskGroupings = [
  "due",
  "property",
  "project",
  "assignee",
  "status",
  "priority",
  "none",
] as const;
export const taskSortValues = [
  "due",
  "priority",
  "updated",
  "created",
  "title",
] as const satisfies readonly TaskSort[];
export const taskStatusValues = [
  "open",
  "inProgress",
  "blocked",
  "done",
  "cancelled",
] as const satisfies readonly TaskStatus[];
export const taskPriorityValues = [
  "low",
  "normal",
  "high",
  "urgent",
] as const satisfies readonly TaskPriority[];
export const dueFilters = ["overdue", "today", "thisWeek", "next30", "noDate"] as const;

const idOrNoneSchema = z.union([z.literal("none"), z.uuid()]);

export const tasksSearch = propertyFilterSearch.extend({
  view: lenient(z.enum(taskViews)),
  display: lenient(z.enum(taskDisplays)),
  group: lenient(z.enum(taskGroupings)),
  sort: lenient(z.enum(taskSortValues)),
  assignee: lenient(idOrNoneSchema),
  project: lenient(idOrNoneSchema),
  status: lenient(z.enum(taskStatusValues)),
  priority: lenient(z.enum(taskPriorityValues)),
  due: lenient(z.enum(dueFilters)),
  task: lenient(z.uuid()),
});

export type TasksSearch = z.infer<typeof tasksSearch>;
